<template>
  <v-menu v-model="menuToggled" bottom offset-y transition="scale-transition">
    <template v-slot:activator="{ on }">
      <mf-button
        data-userflow-id="new-flow-option"
        label="Nova opção"
        icon="add"
        icon-position="left"
        color="marca-0-l40"
        text-transform="none"
        depressed
        @click="menuToggled = true"
      ></mf-button>
    </template>
    <v-list>
      <v-list-item v-for="item in items" :key="`option-${item.handle}`" @click="newOption(item.handle)">
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  data: () => ({
    menuToggled: false,
  }),
  computed: {
    items() {
      return [
        { name: 'Resposta de texto', handle: 'simple_response' },
        { name: 'Encaminhar para disparador', handle: 'forward_to_sender' },
      ]
    },
  },

  methods: {
    newOption(handle) {
      this.$emit('newOption', { id: uuidv4(), handle })
    },
  },
}
</script>
